import { useContext } from 'react'
import { AuthContext } from 'shared/context/auth-context'
import { Button, Tooltip } from 'antd';
import { LogoutOutlined } from '@ant-design/icons';

export default function LogoutSubmission() {
    const { logout } = useContext(AuthContext)

    return (
        <Tooltip title="Αποσύνδεση">
            <Button onClick={logout} type="dashed" icon={<LogoutOutlined />} style={{backgroundColor : '00CBFF', opacity:0.6}}/>
        </Tooltip>
    )
}